import { Extent } from '@models/api/Extent'
import { Basemap } from 'src/models/Basemap'

const isProduction = process.env.NODE_ENV === 'production'
const isPreproduction = process.env.NODE_ENV === 'pre'
const isDev = !isProduction && !isPreproduction
const envApiUrl = import.meta.env.VITE_TEST
let { hostname } = window.location

const apiUrl =
  envApiUrl ??
  (isProduction
    ? `https://api.weathermap.site`
    : `https://api-preprod.weathermap.site`)

const localFileGeneratorUrl = `http://localhost:3002`
const fileGeneratorUrl = isProduction
  ? `https://filegenerator.weathermap.site`
  : localFileGeneratorUrl

const isLocalFileGeneratorActive = false
const NDVIDomain = isProduction
  ? 'https://files.weathermap.site'
  : 'https://files.staging.weathermap.site'

if (isDev || hostname.includes('weathermap')) {
  // Allow ngrok usage in dev
  hostname = 'weathermap.site'
}

export default {
  isProduction: isProduction,
  isPreproduction: isPreproduction,
  baseURL: apiUrl,
  localFileGeneratorUrl,
  fileGeneratorUrl,
  isLocalFileGeneratorActive,
  apiURL: apiUrl + '/v1',
  filesURL: apiUrl + '/', // + '/files/'
  geocoderURL: 'https://nominatim.openstreetmap.org/',
  supportEmail: 'mailto:soporte@weathermap.site',
  ArcGISToken: {
    urlToken: 'https://www.arcgis.com/sharing/rest/oauth2/token',
    serverLayer:
      'https://sentinel.arcgis.com/arcgis/rest/services/Sentinel2/ImageServer',
    client_id: 'nF0IN0uXu24Tc9J8',
    client_secret: 'fc46700adecc4d57b2922cae82a563d6',
    grant_type: 'client_credentials'
  },

  NDVIBasemap: {
    id: 'NDVI',
    title: 'NDVI',
    url: 'https://sentinel.arcgis.com/arcgis/rest/services/Sentinel2/ImageServer',
    type: 'imageLayer',
    key: 'dccafe125bbe4e2bb3315393acbd4701'
  } as Basemap,

  NDVIDomain,

  GOOGLE_ANALYTICS_ID: 'G-YN8TB938GZ',
  esriApiKey:
    'AAPK9ae04820a9b24dd4929c3851c7048d97L8Z6YE-I-VC5xNk7iOB5cr5GR7Fws5Q5n5GonZL9HlmjWEt4O_0h1x4CErnJidL-',

  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
  stationsExtent: [
    [26, -23],
    [44.2768869, 6.6689258]
  ],
  spainExtent: Extent.toLeafletExtent({
    XMAX: 4.42,
    XMIN: -11.13,
    YMAX: 44.61,
    YMIN: 34.98
  })
}
